  export const Contacts = [
    {
      name: "Instagram",
      url: "https://instagram.com/ChefMartinOssa",
      icon: "data:image/svg+xml;utf8,<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><defs><linearGradient id='ig-gradient' x1='0%' y1='0%' x2='100%' y2='100%'><stop offset='0%' stop-color='%23f58529'/><stop offset='50%' stop-color='%23dd2a7b'/><stop offset='100%' stop-color='%23515bd4'/></linearGradient></defs><rect width='24' height='24' rx='6' fill='url(%23ig-gradient)'/><path d='M12 7.2A4.8 4.8 0 1 0 12 16.8A4.8 4.8 0 1 0 12 7.2Z' stroke='white' stroke-width='1.5'/><circle cx='17.2' cy='6.8' r='1' fill='white'/></svg>"
    },
    {
      name: "WhatsApp",
      url: "https://wa.me/3128716875",
      icon: "https://cdn-icons-png.flaticon.com/512/124/124034.png"
    }
  ]
